import alt from 'components/Dispatcher';
import FolderActions from 'actions/inbox/FolderActions';
import {List} from 'immutable';
import {Store} from '@store/@types/alt/Store';
import Folder from 'records/Folder';

interface FolderStoreState {
  folders: List<Folder>;
  isLoading: boolean;
  wasError: boolean;
}

class FolderStore extends Store<FolderStoreState> {
  constructor() {
    super();
    this.state = {
      folders: List(),
      isLoading: true,
      wasError: false,
    };
    this.bindActions(FolderActions);
  }

  fetchFolders() {
    this.setState({
      isLoading: true,
      wasError: false,
    });
  }

  fetchFoldersSuccess(folders) {
    this.setState({
      isLoading: false,
      folders,
    });
  }

  fetchFoldersError(folderId) {
    this.setState({isLoading: false, wasError: true});
  }

  createFolderSuccess(folder) {
    this.setState({folders: this.state.folders.push(folder)});
  }

  deleteFolderSuccess(folderId) {
    this.setState({
      folders: this.state.folders.filter(folder => folder.id !== folderId),
    });
  }
}

export default alt.createStore(FolderStore);
